import ProgressPart from './ProgressPart';

export default ProgressPart;
